export const locationKeys = ["pamir", "shurabad", "nurek"];

export const locationImages = {
  pamir: "murgab",
  shurabad: "shurabad",
  nurek: "nurek",
};
